import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { BankAccountsRoutingModule } from './bank-accounts-routing.module';
import { BankAccountsComponent } from './bank-accounts.component';
/* import { AdminService } from '../../../../services/Admin.service'; */

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTableModule } from 'angular2-datatable';
import { RouterModule } from '@angular/router';



import { NgSelectModule } from '@ng-select/ng-select';
import { AddBankAccountComponent } from './add-bank-account/add-bank-account.component';
import { UpdateBankAccountComponent } from './update-bank-account/update-bank-account.component';
import { SharedComponentsModule } from '../../../../shared-components/shared-components.module';
import { NgxPaginationModule } from 'ngx-pagination';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DataTableModule,
    RouterModule,
    BankAccountsRoutingModule,
    NgxPaginationModule,
    NgSelectModule
    , SharedComponentsModule
  ],
  declarations: [
    BankAccountsComponent,
    AddBankAccountComponent,
    UpdateBankAccountComponent
  ]
})
export class BankAccountModule { }



// WEBPACK FOOTER //
// ./src/app/pages/client/my-settings/bank-accounts/bank-accounts.module.ts